import React, { forwardRef } from 'react';
import { string, func, arrayOf, object, array, bool } from 'prop-types';
import { noop } from 'lodash';
import Autosuggest from 'react-autosuggest';
import {
    getSuggestionTitle,
    getSectionSuggestions,
    shouldRenderSuggestions,
} from './helpers';
import { useMobileResize } from './hooks/useMobileResize';
import { useSuggestions } from './hooks/useSuggestions';

const Suggestions = (
    {
        values = [],
        inputRef,
        addTag = noop,
        suggestions = [],
        onSuggestionsFetchRequested = noop,
        className,
        isMobile,
        pickerContainerRef,
        ...props
    },
    forwardedRef
) => {
    const {
        theme,
        autosuggestInputProps,
        onSuggestionSelected,
        renderSectionTitle,
        renderSuggestion,
    } = useSuggestions({
        props,
        isMobile,
        values,
        addTag,
        className,
        inputRef,
    });

    useMobileResize({ pickerContainerRef, isMobile, values });

    return (
        <Autosuggest
            ref={forwardedRef}
            style={{ color: 'red' }}
            theme={theme}
            suggestions={suggestions}
            multiSection={true}
            renderSuggestion={renderSuggestion}
            renderSectionTitle={renderSectionTitle}
            getSuggestionValue={getSuggestionTitle}
            getSectionSuggestions={getSectionSuggestions}
            onSuggestionSelected={onSuggestionSelected}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={noop}
            shouldRenderSuggestions={shouldRenderSuggestions}
            inputProps={autosuggestInputProps}
            alwaysRenderSuggestions={isMobile}
        />
    );
};

Suggestions.propTypes = {
    values: arrayOf(string),
    onSuggestionsFetchRequested: func,
    suggestions: array,
    addTag: func,
    inputRef: object,
    className: string,
    isMobile: bool,
    pickerContainerRef: object,
};

export default forwardRef(Suggestions);
